import BubbleCommon, {
  realtimeStreamingCCV,
  realtimeStreamingLiveChats,
  realtimeStreamingLiveDuration,
} from '@op/components/BubbleCommon';
import useLanguage from '@op/hooks/useLanguage';
import React, { useMemo } from 'react';
import { Col, H3, Row } from 'tea-component';
import './index.scss';
import { IRealtimeStreamingDetail } from '@op/pages/RealtimeStreaming/type';
import TableMiniChart from '@op/pages/RealtimeStreaming/component/TableMiniChart';
import PieMini from './PieMini';
import { DBO_TM, DBO_V } from '@op/utils/format';

export default function StreamingMetrics({
  data,
}: {
  data: IRealtimeStreamingDetail;
}) {
  const { formatMessage } = useLanguage();

  const chatTotal = useMemo(() => {
    const { positive = 0, negative = 0, neutral = 0 } = data.live_chats || {};
    return positive + negative + neutral;
  }, [data]);

  const timeline = useMemo(() => {
    const { timeline } = data || {};

    return { timeline };
  }, [data]);

  return (
    <Row className="dbo-streaming-metrics-wrapper">
      <Col span={6}>
        <div className="dbo-streaming-metrics-item">
          <div className="dbo-streaming-metrics-item-value">
            <BubbleCommon tipsMap={realtimeStreamingLiveDuration}>
              <H3 className="dbo-streaming-metrics-item-value-title">
                {formatMessage('Duration-1')}
              </H3>
            </BubbleCommon>
            <div className="dbo-streaming-metrics-item-value-desc">
              {DBO_TM.duration(data?.live_duration || 0)}
            </div>
          </div>
        </div>
      </Col>

      <Col span={9}>
        <div className="dbo-streaming-metrics-item">
          <div className="dbo-streaming-metrics-item-value">
            <BubbleCommon tipsMap={realtimeStreamingCCV}>
              <H3 className="dbo-streaming-metrics-item-value-title">
                {formatMessage('CCV')}
              </H3>
            </BubbleCommon>
            <div className="dbo-streaming-metrics-item-value-desc">
              {DBO_V.reviews(
                (data?.live_viewer || 0) > 0 ? data.live_viewer! : 0,
              )}
            </div>
          </div>
          <div className="dbo-streaming-metrics-item-chart">
            <TableMiniChart
              colorMap={{
                areaStart: 'rgba(145, 70, 255, 0.75)',
                areaEnd: 'rgba(145, 70, 255, 0.00)',
                line: '#9146FF',
              }}
              height={66}
              data={timeline}
            ></TableMiniChart>
          </div>
        </div>
      </Col>
      <Col span={9}>
        <div className="dbo-streaming-metrics-item">
          <div className="dbo-streaming-metrics-item-value --long">
            <BubbleCommon tipsMap={realtimeStreamingLiveChats}>
              <H3 className="dbo-streaming-metrics-item-value-title">
                {formatMessage('Number of Live Chats-1')}
              </H3>
            </BubbleCommon>
            <div className="dbo-streaming-metrics-item-value-desc">
              {DBO_V.reviews(chatTotal)}
            </div>
          </div>
          {chatTotal > 0 && (
            <div className="dbo-streaming-metrics-item-chart">
              <PieMini
                data={data?.live_chats}
                liveTime={data.live_time}
              ></PieMini>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
}
